import { createContext } from 'react';

const controlContext = createContext();

export default controlContext;